import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import config from "../../../config";
import { useAuth } from "../../../context/AuthContext";
import { clearAuthToken, setAuthToken } from "../../../utils/tokenStorage";
import { clearRefreshTokenExpiry } from "../../../utils/sessionExpiry";
import Cookies from "js-cookie";
import { onLoginSuccess } from "./TrackingHandler";
import { useDispatch } from "react-redux";
import { login } from "../../../user";

const LoginWithLink = () => {
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get("accessToken");
  const requestor_id = searchParams.get("requestor_id");
  localStorage.setItem("requestor_id", requestor_id);
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const { isAuthenticated } = useAuth();
  const { setIsAuthenticated } = useAuth();
  const dispatch = useDispatch();
  const demoUserDetails = async (requestor_id) => {
    if (!requestor_id) return;

    try {
      const { data } = await axios.get(
        `${config.API_BASE_URL}api/get-meta/${requestor_id}`
      );

      const userData = data?.data;
      if (!userData) return;

      const { name, email, phone } = userData;

      if (name) localStorage.setItem("demo_user_name", name);
      if (email) localStorage.setItem("demo_user_email", email);
      if (phone) localStorage.setItem("demo_user_phone", phone);
    } catch (error) {
      console.error("Error fetching demo user details:", error);
    }
  };

  const saveDemoRole = async (requestor_id, employeeRole) => {
    try {
      await axios.post(`${config.API_BASE_URL}api/save-demo-role`, {
        requestor_id: requestor_id,
        employee_role: employeeRole,
      });
    } catch (error) {
      console.error("Error saving demo role:", error);
    }
  };

  useEffect(() => {
    demoUserDetails(requestor_id);
    if (!accessToken) {
      setStatus("error");
      return;
    }
    axios
      .post(`${config.API_BASE_URL}auth/verify-login-link`, { accessToken })
      .then((response) => {
        setStatus("success");
        if (response.status === 200) {
          setAuthToken(response.data.accessToken);
          const { user } = response.data;
          const responseCompanyName = user?.company?.name
            ?.trim()
            ?.replace(/\s+/g, "-")
            .toLowerCase();
          const sessionDuration = response.data.sessionDuration;
          const refreshTokenExpiry = Date.now() + sessionDuration;
          Cookies.set("refreshTokenExpiry", `${refreshTokenExpiry}`, {
            secure: true,
            sameSite: "None",
            path: "/",
            expires: sessionDuration / (1000 * 60 * 60 * 24),
          });
          const companyURL = user.company.name
            ?.trim()
            ?.replace(/\s+/g, "-")
            .toLowerCase();
          localStorage.setItem("refreshToken", response.data.refreshToken);
          localStorage.setItem("refreshTokenExpiry", refreshTokenExpiry);
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("colorschema", user.company.colour);
          localStorage.setItem("companyColor", user.company.colour);
          localStorage.setItem("companyName", user.company.name);
          localStorage.setItem("employee_role", user?.employee_role);
          localStorage.setItem("company_url", companyURL);
          localStorage.setItem("multipleEmployer", 0);
          localStorage.setItem("demoEmployee", 1);
          localStorage.setItem("employeeOfficialEmail", user?.email);

          dispatch(login(user));
          onLoginSuccess(user?.id, user?.work_start_time, user?.work_end_time);
          setIsAuthenticated(true);
          navigate(`../${responseCompanyName}/`);
        } else {
          setStatus("error");
        }
      })
      .then(() => {
        const demoEmployeeRole = localStorage.getItem("employee_role");
        saveDemoRole(requestor_id, demoEmployeeRole);
      })
      .catch(() => setStatus("error"));
  }, [accessToken, navigate, requestor_id]);

  if (isAuthenticated) {
    const companyName = localStorage.getItem("companyName");
    if (!companyName) {
      setIsAuthenticated(false);
      clearAuthToken();
      clearRefreshTokenExpiry();
      navigate("/");
      return;
    }
    navigate(`../${companyName.trim()?.replace(/\s+/g, "-").toLowerCase()}`);
    return;
  }

  if (status === "loading")
    return <p className="text-center">Validating login link…</p>;
  if (status === "error")
    return <p className="text-center text-danger">* Invalid login link !</p>;
  if (status === "success")
    return <p className="text-center">Login successful! Redirecting...</p>;
  return null;
};

export default LoginWithLink;
